import gql from 'graphql-tag';

export const mutationLogAppError = gql`
  mutation logAppError (
    $message: String!
    $extraAttributes: JSON!
  ) {
    logAppError (
      message: $message
      extraAttributes: $extraAttributes
    )
  }
`;
export default mutationLogAppError;
